import React from 'react';

import { SearchLinkSkeleton } from './search-link-skeleton';
export const SearchLinkSkeletons = (): React.JSX.Element => {
	return (
		<>
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
			<SearchLinkSkeleton />
		</>
	);
};
